export enum TicketsAction {
  DOWNLOAD = 'download',
  PRINT = 'print',
  NETWORK_PRINT = 'network_print',
}
